export const SET_NODE_LIST = 'SET_NODE_LIST'
export const SET_NODE_LIST_PAGE = 'SET_NODE_LIST_PAGE'
export const SET_NODE_LIST_PAGE_TOTAL = 'SET_NODE_LIST_PAGE_TOTAL'
export const SET_NODE_LIST_STATISTICS = 'SET_NODE_LIST_STATISTICS'
export const SET_NODE_LIST_QUERY = 'SET_NODE_LIST_QUERY'
export const SET_NODE_LIST_PAGE_SIZE = 'SET_NODE_LIST_PAGE_SIZE'
export const SET_NODE_LIST_SEARCHING = 'SET_NODE_LIST_SEARCHING'
export const IF_SELECT_ALLSIZE = 'IF_SELECT_ALLSIZE'
export const SET_DATA_LOADED_SIGN = 'SET_DATA_LOADED_SIGN'
export const IS_QUERY = 'IS_QUERY'
export const SET_ALL_SIZE = 'SET_ALL_SIZE'
export const SET_NODE_LIST_SORT = 'SET_NODE_LIST_SORT'
export const SET_GPU_PROPERTY_LIST = 'SET_GPU_PROPERTY_LIST'
export const SET_EXPORTING = 'SET_EXPORTING'
export const SET_ALL_NODE_ITEMS_LIST = 'SET_ALL_NODE_ITEMS_LIST'
// rentNodeList
export const SET_RENT_LIST = 'SET_RENT_LIST'
export const SET_RENT_LIST_PAGE = 'SET_RENT_LIST_PAGE'
export const SET_RENT_LIST_PAGE_TOTAL = 'SET_RENT_LIST_PAGE_TOTAL'
export const SET_RENT_LIST_QUERY = 'SET_RENT_LIST_QUERY'
export const SET_RENT_LIST_PAGE_SIZE = 'SET_RENT_LIST_PAGE_SIZE'
export const SET_RENT_LIST_SEARCHING = 'SET_RENT_LIST_SEARCHING'
export const SET_RENTAL_VIEW_STATE = 'SET_RENTAL_VIEW_STATE'
export const SET_RENTAL_VIEW_QUERY = 'SET_RENTAL_VIEW_QUERY'
export const SET_RENTAL_DASHBOARD = 'SET_RENTAL_DASHBOARD'
// transferList
export const SET_TRANSFER_LIST = 'SET_TRANSFER_LIST'
export const SET_TRANSFER_LIST_PAGE = 'SET_TRANSFER_LIST_PAGE'
export const SET_TRANSFER_LIST_PAGE_TOTAL = 'SET_TRANSFER_LIST_PAGE_TOTAL'
export const SET_TRANSFER_LIST_QUERY = 'SET_TRANSFER_LIST_QUERY'
export const SET_TRANSFER_LIST_PAGE_SIZE = 'SET_TRANSFER_LIST_PAGE_SIZE'
export const SET_TRANSFER_LIST_SEARCHING = 'SET_TRANSFER_LIST_SEARCHING'
export const SET_RENTAL_RECORD_STATE = 'SET_RENTAL_RECORD_STATE'
export const SET_RENTAL_RECORD_QUERY = 'SET_RENTAL_RECORD_QUERY'
// machineDetailList
export const SET_MACHINE_DETAIL_LIST = 'SET_MACHINE_DETAIL_LIST'
export const SET_MACHINE_DETAIL_LIST_PAGE = 'SET_MACHINE_DETAIL_LIST_PAGE'
export const SET_MACHINE_DETAIL_LIST_PAGE_TOTAL = 'SET_MACHINE_DETAIL_LIST_PAGE_TOTAL'
export const SET_MACHINE_DETAIL_LIST_QUERY = 'SET_MACHINE_DETAIL_LIST_QUERY'
export const SET_MACHINE_DETAIL_LIST_PAGE_SIZE = 'SET_MACHINE_DETAIL_LIST_PAGE_SIZE'
export const SET_MACHINE_DETAIL_LIST_ID = 'SET_MACHINE_DETAIL_LIST_ID'
export const SET_MACHINE_DETAIL_LIST_STATUS = 'SET_MACHINE_DETAIL_LIST_STATUS'
// machineDetailList
export const SET_OPERATE_RECORD_LIST = 'SET_OPERATE_RECORD_LIST'
export const SET_OPERATE_RECORD_LIST_PAGE = 'SET_OPERATE_RECORD_LIST_PAGE'
export const SET_OPERATE_RECORD_LIST_PAGE_TOTAL = 'SET_OPERATE_RECORD_LIST_PAGE_TOTAL'
export const SET_OPERATE_RECORD_LIST_PAGE_SIZE = 'SET_OPERATE_RECORD_LIST_PAGE_SIZE'
export const SET_OPERATE_RECORD_LIST_ID = 'SET_OPERATE_RECORD_LIST_ID'

export const SET_HARDWARE_RECOMMEND_LIST = 'SET_HARDWARE_RECOMMEND_LIST'
export const SET_HARDWARE_RECOMMEND_TOTAL = 'SET_HARDWARE_RECOMMEND_TOTAL'
